import React from 'react'
import { css } from '@mxenabled/cssinjs'

import { DEFAULT_DONUT_SIZE, DEFAULT_STROKE_WIDTH } from '../../constants'

export interface Segment {
  percent: number
  color: string
}

export interface MultiSegmentDonutProps {
  children: React.ReactNode
  hasGap?: boolean
  segments: Segment[]
  size?: number
  strokeWidth?: number
}

const MultiSegmentDonut: React.FC<MultiSegmentDonutProps> = ({
  hasGap = false,
  segments,
  size = DEFAULT_DONUT_SIZE,
  strokeWidth = DEFAULT_STROKE_WIDTH,
  children,
}) => {
  const styles = getStyles(size)

  const radius = (size - strokeWidth) / 2
  const halfSize = size / 2

  let offset = -90 - (hasGap ? 1 : 0)

  let length = 0

  return (
    <div className={`mx-cmn-multi-segment-donut ${styles}`}>
      <svg height={size} width={size}>
        <circle
          cx={halfSize}
          cy={halfSize}
          fill="none"
          r={radius}
          stroke="#E4E8EE"
          strokeWidth={strokeWidth}
        />
        {segments.map((segment, index) => {
          offset += 360 * length + (hasGap ? 1 : 0)
          length = (segment.percent - (hasGap ? 0.3 : 0)) / 100

          return (
            <circle
              cx={halfSize}
              cy={halfSize}
              fill="none"
              key={index}
              r={radius}
              stroke={segment.color}
              strokeDasharray={2 * Math.PI * radius}
              strokeDashoffset={2 * Math.PI * radius * (1 - length)}
              strokeWidth={strokeWidth}
              transform={`rotate(${offset}, ${halfSize}, ${halfSize})`}
            />
          )
        })}
      </svg>
      <div className="mx-cmn-multi-segment-donut-children">{children}</div>
    </div>
  )
}

const getStyles = (size: number) =>
  css({
    height: size,
    marginTop: `-8px`,
    position: 'relative',
    width: size,
    '& .mx-cmn-multi-segment-donut-children': {
      left: '50%',
      position: 'absolute',
      textAlign: 'center',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  })

export default MultiSegmentDonut
